import axios from 'axios';
import {getAuthUrl} from "../utils";

const token = localStorage.getItem('user_token');

// Mimics axios 0.x default param serializer: nested objects inside array values
// are JSON-stringified rather than expanded to bracket notation. Backend endpoints
// rely on `?filter[]={"id":"name","value":"x"}` being json_decode-able server-side.
export const legacyParamsSerializer = (params) => {
    const parts = [];
    const encode = encodeURIComponent;
    Object.keys(params).forEach((key) => {
        let val = params[key];
        if (val === null || typeof val === 'undefined') return;
        const values = Array.isArray(val) ? val : [val];
        const outKey = Array.isArray(val) ? `${key}[]` : key;
        values.forEach((v) => {
            if (v instanceof Date) v = v.toISOString();
            else if (v !== null && typeof v === 'object') v = JSON.stringify(v);
            parts.push(`${encode(outKey)}=${encode(v)}`);
        });
    });
    return parts.join('&');
};

export const client = axios.create({
    baseURL: process.env.REACT_APP_API_V2,
    timeout: 90000,
    paramsSerializer: legacyParamsSerializer,
    headers: {
        common: {
            'Authorization': token ? `Bearer ${token}` : ""
        },
        post: {
            'Content-Type': 'application/json'
        }
    }
})

client.interceptors.response.use(function (response) {
    if (response.headers['x-token']) {
        localStorage.setItem('user_token', response.headers['x-token']);
    }

    if (response.headers['current-time']) {
        localStorage.setItem('currentTime', response.headers['current-time']);
    }

    return response;
}, function (error) {

    if (process.env.NODE_ENV === 'development') {
        if(error.message) {
            console.log("ERROR MESSAGE: " + error.message);
        }

        if(error.response && error.response.status) {
            console.log("STATUS CODE: " + error.response.status);
        }
    }

    //Need for login
    if(error.response !== undefined && error.response.status === 401){
        localStorage.setItem("redirect_after_login", window.location);
        window.location = getAuthUrl();
    }

    return Promise.reject(error);
})

export const saveToken = (payload) => {
    localStorage.setItem("user_token", payload.token);
    document.cookie = "BEARER=" + payload.token + "; path=/;";
    setToken(payload.token);
}

export const setToken = (token) => {
    client.defaults.headers = {
        'Authorization': token ? `Bearer ${token}` : "",
        post: {
            'Content-Type': 'application/json'
        }
    }
}
